import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import MyFiles from "./MyFiles";
import { useUser } from "../hooks/Authorize";

const ResourceViewer = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const ownerId = platformUser._id;
  var isViewer = true;
  const parentId = queryParams.get("parentId");
  const resourceId = queryParams.get("id");

  const [items, setItems] = useState([]);
  const [file, setFile] = useState([]);
  const [accessDenied, setAccessDenied] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (parentId) {
          const response = await axios.get(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs`, {
            params: { parentId, ownerId,isViewer},
          });
          if (response.data.error && response.data.message === "ACCESS_DENIED") {
            setAccessDenied(true);
            setItems([]);
          } else {
            setItems(response.data);
          }
        } else if (resourceId) {
          const response = await axios.get(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs`, {
            params: { resourceId, ownerId,isViewer },
          });
          if (response.data.error && response.data.message === "ACCESS_DENIED") {
            setAccessDenied(true);
            setFile([]);
          } else {
            setFile(response.data);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentId, resourceId, isViewer, ownerId]);

  if (resourceId && file) {
    return <MyFiles overrideItems={file} accessDenied={accessDenied} />;
  }

  return <MyFiles overrideItems={items} accessDenied={accessDenied} />;
};

export default ResourceViewer;
